export const keys = {
  AGO: "AGO",
  ADD: "ADD",
  ALL: "ALL",
  APPOINTMENT_DETAILS: "APPOINTMENT_DETAILS",
  APPOINTMENT_DETAILS_INTRO: "APPOINTMENT_DETAILS_INTRO",
  APPOINTMENTS: "APPOINTMENTS",
  ARRIVAL: "ARRIVAL",
  AUTO_REFRESH: "AUTO_REFRESH",
  AUTO_REFRESH_TEXT: "AUTO_REFRESH_TEXT",
  AIR_SLEEVES: "AIR_SLEEVES",
  BAG: "BAG",
  BILLING: "BILLING",
  BOBTAIL: "BOBTAIL",
  CANCEL: "CANCEL",
  CARTS: "CARTS",
  CLEAR: "CLEAR",
  CONSUMABLES: "CONSUMABLES",
  CUSTOMER_PACKAGE: "CUSTOMER_PACKAGE",
  CUSTOMER_RETURN: "CUSTOMER_RETURN",
  DISASTER_RELIEF: "DISASTER_RELIEF",
  DONATION: "DONATION",
  EMPTY_BAGS: "EMPTY_BAGS",
  EMPTY_CARTS: "EMPTY_CARTS",
  EMPTY_PODS: "EMPTY_PODS",
  EMPTY_SKIDS: "EMPTY_SKIDS",
  EMPTY_TOTES: "EMPTY_TOTES",
  EMPTY_ULD: "EMPTY_ULD",
  FULL_PODS: "FULL_PODS",
  GARBAGE: "GARBAGE",
  GAYLORDS: "GAYLORDS",
  INBOUND_INVENTORY: "INBOUND_INVENTORY",
  MAINTENANCE: "MAINTENANCE",
  NON_INVENTORY: "NON_INVENTORY",
  PALLETS: "PALLETS",
  PALLET_SLEEVES: "PALLET_SLEEVES",
  RECOVERY: "RECOVERY",
  REDIRECT: "REDIRECT",
  RETURN: "RETURN",
  REUSABLES: "REUSABLES",
  SHUTTLE: "SHUTTLE",
  SKIDS: "SKIDS",
  SMALL_PARCEL: "SMALL_PARCEL",
  TOMY: "TOMY",
  TRAILER_HAND_OFF: "TRAILER_HAND_OFF",
  TOTES: "TOTES",
  UNIVERSAL_PALLET: "UNIVERSAL_PALLET",
  UNIVERSAL_PLASTIC_PALLET: "UNIVERSAL_PLASTIC_PALLET",
  UPP: "UPP",
  VENDOR_RETURN: "VENDOR_RETURN",
  NO_LOAD_TYPE: "NO_LOAD_TYPE",
  NO_LOAD_SUB_TYPE: "NO_LOAD_SUB_TYPE",
  CONTENT_TAGS: "CONTENT_TAGS",
  CONTENT_TAGS_EMPTY_STATUS_TOOLTIP: "CONTENT_TAGS_EMPTY_STATUS_TOOLTIP",
  DEPARTURE: "DEPARTURE",
  DETAILS: "DETAILS",
  DEVICE: "DEVICE",
  DRIVER_READ: "DRIVER_READ",
  DURATION: "DURATION",
  DWELL_TIME: "DWELL_TIME",
  EDIT_CONTENT_TAGS: "EDIT_CONTENT_TAGS",
  EDIT_EMPTY_STATUS: "EDIT_EMPTY_STATUS",
  EDIT_NOTES: "EDIT_NOTES",
  EMPTY: "EMPTY",
  EMPTY_STATUS: "EMPTY_STATUS",
  ENTER_NOTES: "ENTER_NOTES",
  EQUIPMENT: "EQUIPMENT",
  EQUIPMENT_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT:
    "EQUIPMENT_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT",
  EQUIPMENT_REPORT_NOT_ENABLED: "EQUIPMENT_REPORT_NOT_ENABLED",
  EQUIPMENT_REPORT_RETRIEVAL_ERROR_TEXT: "EQUIPMENT_REPORT_RETRIEVAL_ERROR_TEXT",
  EQUIPMENT_TYPE: "EQUIPMENT_TYPE",
  ERROR: "ERROR",
  FALSE: "FALSE",
  FROM_1_TO_6_HR: "FROM_1_TO_6_HR",
  FROM_6_TO_24_HR: "FROM_6_TO_24_HR",
  FROM_24_HR: "FROM_24_HR",
  FROM_30_TO_60_MIN: "FROM_30_TO_60_MIN",
  HELP: "HELP",
  IDENTIFIER: "IDENTIFIER",
  INBOUND: "INBOUND",
  IYI_STATUS: "IYI_STATUS",
  LANGUAGE: "LANGUAGE",
  LATE_FOR: "LATE_FOR",
  LATEST_MESSAGE: "LATEST_MESSAGE",
  LESS_THAN_30_MIN: "LESS_THAN_30_MIN",
  LOAD_CONDITION: "LOAD_CONDITION",
  LOAD_ID: "LOAD_ID",
  LOAD_STATUS: "LOAD_STATUS",
  LOAD_SUB_TYPE: "LOAD_SUB_TYPE",
  LOAD_TYPE: "LOAD_TYPE",
  LOCATIONS: "LOCATIONS",
  LOCATION: "LOCATION",
  MESSAGE_SENT: "MESSAGE_SENT",
  MOVE_EQUIPMENT: "MOVE_EQUIPMENT",
  NEXT_STATUS: "NEXT_STATUS",
  NO: "NO",
  NOTES: "NOTES",
  NO_RESULTS: "NO_RESULTS",
  NO_TAGS_SAVED_TEXT: "NO_TAGS_SAVED_TEXT",
  NON_EMPTY: "NON_EMPTY",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  OUTBOUND: "OUTBOUND",
  PAGINATE: "PAGINATE",
  PROGRESS: "PROGRESS",
  PROGRESS_ERROR_TOOLTIP: "PROGRESS_ERROR_TOOLTIP",
  PURPOSE: "PURPOSE",
  REFRESH: "REFRESH",
  ROWS: "ROWS",
  SAVE: "SAVE",
  SCAC_CODE: "SCAC_CODE",
  SEARCH: "SEARCH",
  SELECT_ACCOUNT: "SELECT_ACCOUNT",
  SHIPPER_ACCOUNT: "SHIPPER_ACCOUNT",
  SHOW_ALL: "SHOW_ALL",
  STATUS: "STATUS",
  SUMMARY: "SUMMARY",
  TAGS_TO_BE_SAVED: "TAGS_TO_BE_SAVED",
  TYPE: "TYPE",
  TRUE: "TRUE",
  VIEW: "VIEW",
  WHAT_IS_NEW: "WHAT_IS_NEW",
  WRANGLING_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT:
    "WRANGLING_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT",
  WRANGLING_REPORT_NOT_ENABLED: "WRANGLING_REPORT_NOT_ENABLED",
  WRANGLING_REPORT_RETRIEVAL_ERROR_TEXT: "WRANGLING_REPORT_RETRIEVAL_ERROR_TEXT",
  YES: "YES",
  ROUTE_ERROR_CHUNK: "ROUTE_ERROR_CHUNK",
  ROUTE_ERROR_COPY_LOGS: "ROUTE_ERROR_COPY_LOGS",
  ROUTE_ERROR_REASON: "ROUTE_ERROR_REASON",
  ROUTE_ERROR_GENERIC: "ROUTE_ERROR_GENERIC",
  RELOAD_PAGE: "RELOAD_PAGE",
  EVENT_REPORT_VISIT_OLD_VIEW: "EVENT_REPORT_VISIT_OLD_VIEW",
  VEHICLE_TYPE_TRAILER: "VEHICLE_TYPE_TRAILER",
  VEHICLE_TYPE_TRAILER_SKIRTED: "VEHICLE_TYPE_TRAILER_SKIRTED",
  VEHICLE_TYPE_TRAILER_PUP: "VEHICLE_TYPE_TRAILER_PUP",
  VEHICLE_TYPE_TRAILER_PUP_SKIRT: "VEHICLE_TYPE_TRAILER_PUP_SKIRT",
  VEHICLE_TYPE_TRAILER_PUP_INTERMODAL: "VEHICLE_TYPE_TRAILER_PUP_INTERMODAL",
  VEHICLE_TYPE_TRAILER_INTERMODAL: "VEHICLE_TYPE_TRAILER_INTERMODAL",
  VEHICLE_TYPE_TRAILER_REFRIGERATED: "VEHICLE_TYPE_TRAILER_REFRIGERATED",
  VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM: "VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM",
  VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM_SKIRTED: "VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM_SKIRTED",
  VEHICLE_TYPE_TRAILER_BOX_TRUCK: "VEHICLE_TYPE_TRAILER_BOX_TRUCK",
  VEHICLE_TYPE_TRAILER_DOUBLE: "VEHICLE_TYPE_TRAILER_DOUBLE",
  VEHICLE_TYPE_TRAILER_FLATBED: "VEHICLE_TYPE_TRAILER_FLATBED",
  VEHICLE_TYPE_TRAILER_SOFT: "VEHICLE_TYPE_TRAILER_SOFT",
  VEHICLE_TYPE_SWAP_BODY: "VEHICLE_TYPE_SWAP_BODY",
  VEHICLE_TYPE_BOX_TRUCK: "VEHICLE_TYPE_BOX_TRUCK",
  VEHICLE_TYPE_BOX_TRUCK_2T: "VEHICLE_TYPE_BOX_TRUCK_2T",
  VEHICLE_TYPE_BOX_TRUCK_4T: "VEHICLE_TYPE_BOX_TRUCK_4T",
  VEHICLE_TYPE_BOX_TRUCK_10T: "VEHICLE_TYPE_BOX_TRUCK_10T",
  VEHICLE_TYPE_SPRINTER_VAN: "VEHICLE_TYPE_SPRINTER_VAN",
  VEHICLE_TYPE_BOX_SPRINTER_VAN: "VEHICLE_TYPE_BOX_SPRINTER_VAN",
  VEHICLE_TYPE_TRACTOR: "VEHICLE_TYPE_TRACTOR",
  VEHICLE_TYPE_TRACTOR_FLATBED: "VEHICLE_TYPE_TRACTOR_FLATBED",
  VEHICLE_TYPE_HOSTLER: "VEHICLE_TYPE_HOSTLER",
  VEHICLE_TYPE_CAR: "VEHICLE_TYPE_CAR",
  VEHICLE_TYPE_MOTORCYCLE: "VEHICLE_TYPE_MOTORCYCLE",
  VEHICLE_TYPE_THREE_WHEELER: "VEHICLE_TYPE_THREE_WHEELER",
  VEHICLE_TYPE_PERSON: "VEHICLE_TYPE_PERSON",
  VEHICLE_TYPE_AIRPLANE: "VEHICLE_TYPE_AIRPLANE",
  VEHICLE_TYPE_DOLLY: "VEHICLE_TYPE_DOLLY",
};
